import { gql } from "apollo-boost";

export const ALL_STANDARDS = gql`
  query {
    allStandards {
      edges {
        node {
          standardId
          setLibSetId
          rankId
          standardTime
          effectiveDate
          comments
          gender
          facilityType
          classification
          updateDate
          updateSource
          id
        }
      }
    }
  }
`;
